import React from "react";
import { NavLink } from "react-router-dom";
import {
  LayoutDashboard, Users, Calendar, MessageSquare, Search, CreditCard, Map as MapIcon,
  Trophy, Inbox, DollarSign, Heart,
} from "lucide-react";
import { useI18n } from "../../contexts/I18nContext";
import { useAuth } from "../../contexts/AuthContext";

// Mobile bottom nav — Iter 29 strict role separation. Each role gets exactly
// 5 tabs reflecting their primary jobs-to-be-done.
const buildItems = (t, lang, role) => {
  const dashboard = { to: "/", label: t("dashboard"), icon: LayoutDashboard, end: true };
  const chat = { to: "/chat", label: t("chat"), icon: MessageSquare };
  const calendar = { to: "/calendar", label: t("calendar"), icon: Calendar };

  if (role === "player") {
    return [
      dashboard,
      { to: "/find-coaches", label: lang === "bg" ? "Открий" : "Find", icon: Search },
      { to: "/coaches-map", label: lang === "bg" ? "Карта" : "Map", icon: MapIcon },
      { to: "/bookings", label: lang === "bg" ? "Сесии" : "Sessions", icon: CreditCard },
      chat,
    ];
  }
  if (role === "academy") {
    return [
      dashboard,
      { to: "/children", label: lang === "bg" ? "Играчи" : "Players", icon: Users },
      { to: "/academy/coaches", label: lang === "bg" ? "Треньори" : "Coaches", icon: Trophy },
      { to: "/academy/applications", label: lang === "bg" ? "Заявки" : "Leads", icon: Inbox },
      chat,
    ];
  }
  if (role === "parent") {
    return [
      dashboard,
      calendar,
      { to: "/bookings", label: lang === "bg" ? "Сесии" : "Sessions", icon: CreditCard },
      { to: "/favorites", label: lang === "bg" ? "Любими" : "Saved", icon: Heart },
      chat,
    ];
  }
  // coach (default)
  return [
    dashboard,
    { to: "/children", label: lang === "bg" ? "Играчи" : "Players", icon: Users },
    calendar,
    { to: "/bookings", label: lang === "bg" ? "Резерв." : "Bookings", icon: CreditCard },
    { to: "/earnings", label: lang === "bg" ? "Приходи" : "Earnings", icon: DollarSign },
  ];
};

export default function MobileBottomNav() {
  const { t, lang } = useI18n();
  const { user } = useAuth();
  const items = buildItems(t, lang, user?.role);
  return (
    <nav
      className="md:hidden fixed bottom-0 left-0 right-0 z-40 glass-bottom-nav pb-safe"
      data-testid="mobile-bottom-nav"
    >
      <div className="grid grid-cols-5">
        {items.map((it) => (
          <NavLink
            key={it.to}
            to={it.to}
            end={it.end}
            data-testid={`mbn-${it.to.replace(/^\//, "").replace(/\//g, "-") || "dashboard"}`}
            className={({ isActive }) => `nav-tab ${isActive ? "active" : ""}`}
          >
            <it.icon className="w-5 h-5" />
            <span className="text-[10px] font-mono tracking-widest uppercase truncate w-full text-center px-1">{it.label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
